export default __webpack_public_path__ + "static/media/050_brake_02.56b7b26a.mp3";